function r(t) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(t);
}
function m(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = -1, i = function u(a) {
    e < 0 && (e = a), a - e > n ? (t(a), e = -1) : r(u);
  };
  requestAnimationFrame(i);
}
export {
  m as default
};
